import React from 'react';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { isBrowser } from "react-device-detect";
import ReactStars from "react-rating-stars-component";

const mt15 = {
    marginTop: 15
}

const KnowledgeAndSkillsModuleCard = ({competencia, competencias}) => {
    const legend = [
        {
            key: 1,
            value: 'Bajo'
        },
        {
            key: 2,
            value: 'Regular'
        },
        {
            key: 3,
            value: 'Bueno'
        },
        {
            key: 4,
            value: 'Muy bueno'
        },
        {
            key: 5,
            value: 'Excelente'
        }
    ];

    const inlineStyle = {
        display: 'flex',
        flexFlow: 'row'
    }

    const labelStyle = {
        marginTop: 8,
        marginLeft: 10
    }

    return (
        <>
            <Card>
                <Card.Body className={'p-20'}>
                    <Row>
                        <Col xs={isBrowser ? 6 : 12 }>
                            <Row>
                                <Col xs={isBrowser ? 6 : 12} style={{display: 'flex', alignItems: 'center'  }}>
                                    {
                                        competencia.conocimientoId 
                                        ? <span style={{ fontSize: 20 }}> 
                                            { competencias.find(x => x.id == competencia.conocimientoId)?.descripcion } 
                                        </span>
                                        : "No especificado"
                                    }
                                </Col>
                                <Col xs={isBrowser ? 6 : 12}>
                                    {
                                        competencia.valoracion 
                                        ? <div style={inlineStyle}>
                                            <ReactStars
                                                count={5}
                                                size={25}
                                                value={competencia.valoracion}
                                                activeColor="#00BBEC"
                                                edit={false}
                                            />
                                            <div style={labelStyle}>
                                                { legend.find(x => x.key === competencia.valoracion).value }
                                            </div>
                                        </div>
                                        : "No especificado"
                                    }
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
            <br/>
        </>
    );
};

export default KnowledgeAndSkillsModuleCard;